<template>
  <div class="floating-container">
    <Overlay v-bind:content="overlay.content" v-bind:class="'overlay ' + (overlay.show ? 'show': '')" @close="overlay.show = false" />
    <div class="floating-header">
      <h1>Tests for "{{ strategy.name }}"</h1>
      <button class="small" @click="addTest">+ Add Test</button>
      <router-link to="../"><button class="small">← Go Back</button></router-link>
    </div>
    <div id="test_list">
      <Table v-bind:head="head" v-bind:body="body" />
    </div>
  </div>
</template>

<script>
import Table from "../generics/Table";
import utils from "@/js/utils";
import request from "@/js/request";
import Overlay from "../generics/Overlay";
import CreateTest from "./forms/CreateTest.vue";

const methods = {
  process: {
    tests (tests) {
      return tests.map(test => {
        return {
          key: test.public_key,
          editing_disabled: true,
          data: [
            { html: test.name },
            { html: `<code>${test.label}</code>` },
            { html: test.description },
            { html: utils.formatTest.localeListToString(test.locale) },
            { html: test.proportion * 100 + "%" },
          ],
        };
      });
    },
  },
};

export default {
  name: 'SiteStrategies',
  props: ["strategy", "tests"],
  data () {
    const data = {
      // - name
      // - proportion
      // - label
      // - locale
      // - description
      // device type
      // browser
      // referrer
      // is subscriber
      // payment request
      head: [
        { html: "Name", width: 150 },
        { html: "Label", width: 150 },
        { html: "Description", width: 600 },
        { html: "Locale", width: 200 },
        { html: "Proportion", width: 100, align: "right" },
      ],
      body: [],
      overlay: {
        content: {},
        show: false,
      },
    };

    (async () => {
      data.organization = (await utils.generalInformation()).organization;
    })();

    return data;
  },

  methods: {
    addTest: function () {
      this.$data.overlay.content = { key: CreateTest };
      this.$data.overlay.show = true;
    },
  },

  watch: {
    tests (tests) {
      this.$data.body = methods.process.tests(tests);
    },
  },

  components: {
    Table,
    Overlay,
  },
};
</script>

<style scoped>
#test_list {
  width: 1252px;
}
</style>



// WEBPACK FOOTER //
// src/components/special/SiteStrategyTests.vue